import { render, staticRenderFns } from "./Gangweizhiji.vue?vue&type=template&id=488b1a9f&scoped=true&"
import script from "./Gangweizhiji.vue?vue&type=script&lang=js&"
export * from "./Gangweizhiji.vue?vue&type=script&lang=js&"
import style0 from "./Gangweizhiji.vue?vue&type=style&index=0&id=488b1a9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488b1a9f",
  null
  
)

export default component.exports